import React from 'react';

export default function FormInput({ label, type, id, placeHolder, value, onChange }) {
  return (
    <div className="form_input_container">
      <label htmlFor={id}>{label}</label>
      <input type={type} className="form_input" id={id} placeholder={placeHolder} name={id} value={value} onChange={onChange}/>
    </div>
  )
}
